import { IFieldServer } from "@common/redux/forms/interface";
export const nameDefaultValue: IFieldServer = {
  title: "Name",
  description: "",
  name: "field_set",
  isSection: true,
  fieldType: "SECTION",
  element: "fieldset",
  type: "fieldset",
  grid: {
    width: 1,
  },
  fieldConfig: {
    isPII: false,
    isQrCodeAllowed: false,
  },

  fields: [
    {
      fieldType: "DROPDOWN",
      title: "Salutation",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 4,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "DROPDOWN",
      name: "Salutation",
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
        initialValue: "",
        placeholder: "",
        options: [
          {
            key: "0",
            value: "Mr.",
          },
          {
            key: "1",
            value: "Ms.",
          },
          {
            key: "2",
            value: "Mrs.",
          },
        ],
        sort: {},
      },
    },
    {
      fieldType: "TEXT_INPUT",
      title: "First name",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 4,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "First name",
      // "localId": null,
      rules: [
        {
          rule: "TEXT",
          errorMessage: "Value should be of text type",
        },
      ],
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    // {
    //   fieldType: "TEXT_INPUT",
    //   title: "Middle name",
    //   isVisible: true,
    //   isDisabled: false,
    //   isRequired: false,
    //   grid: {
    //     width: 4,
    //   },
    //   canDelete: true,
    //   canCopy: true,
    //   canAdd: true,
    //   type: "TEXT_INPUT",
    //   name: "Middle name",
    //   // "localId": null,
    //   rules: [
    //     {
    //       rule: "TEXT",
    //       errorMessage: "Value should be of text type",
    //     },
    //   ],
    //   fields: [],
    //   fieldConfig: {
    //     isDuplicateAllowed: true,
    //     isPII: false,
    //     isQrCodeAllowed: false,
    //   },
    // },
    {
      fieldType: "TEXT_INPUT",
      title: "Last name",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 4,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "Last name",
      // localId: null,
      rules: [
        {
          rule: "TEXT",
          errorMessage: "Value should be of text type",
        },
      ],
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
  ],
};
